import { Button, Input } from "./ui";

// Helper function to format numbers without unnecessary trailing zeros
const formatNumber = (num) => {
    return Number(num.toFixed(1));
};

const CornerEdit = (props) => {

    const deleteSelf = ()=>{
        props.floorplanningHelper.deleteCurrentItem();
        props.resetSelected2DEntity();
    }

    const updateCornerElevation = (newElevation)=>{
        props.floorplanningHelper.cornerElevation = newElevation;
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            width: "180px",
            padding: "10px",
            gap: "5px",
        }}>
            <label style={{ fontSize: "12px", marginBottom: "-2px", display: "block" }}>
                Corner Elevation (cm)
            </label>
            <Input
                type="number"
                step={1}
                value = {formatNumber(props.floorplanningHelper.cornerElevation)}
                onChange={(evt)=>{updateCornerElevation(evt.target.value)}}></Input>
            
            <div></div>
            <div></div>
            <div></div>
            
            <Button onClick={deleteSelf}>Delete corner</Button>
        </div>
    );
}

export default CornerEdit;